import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';

export default {
  name: 'connectionhubfornetwork',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  props: [],
  data() {
    return {
      hubzoneid: '',
      listHubZoneData: [],
      routetype: {},
      routetypelist: [{
        value: 1,
        text: 'Local'
      }, {
        value: 3,
        text: 'LineHaul'
      },
      {
        value: 5,
        text: 'BrooksNBonds'
      }, {
        value: 6,
        text: 'Biker'
      }],
      sourceHubId: null,
      listSourceHubNameData: [],
      ConnectionID: [],
      listConnection: [],
      modelArr: [],
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      totalmappedhubs: 0,
      connDestLoading:false,
      checked:[],
      useremail:'',
      zoneLoading:'',
      sourceHubLoading:'',
      connectionLoading:'',
      userData:[],
      sourceHubIdArr:[]
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.userData = userdetail;
    this.getHubZoneData();
  },
  methods: {

    customLabel ({ text, FullConnectionName }) {
      return `${text} – ${FullConnectionName}`;
    },
    SelectSourceHub(selected) {
       this.sourceHubId = selected;

       if (!selected) {
          this.listConnection = [];
          this.ConnectionID = {};
        return;
       }

      this.getConnectionListByHubIDAndConnectionType();
    },

    getConnectionListByHubIDAndConnectionType() {

      // if (Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.routetype).length <= 0) { return false; }
      if (
    !this.sourceHubId || !this.sourceHubId.value ||
    !this.routetype || !this.routetype.value
       ) {
      return;
       }
      this.connectionLoading  = 'Loading Connection Name...'
      this.listConnection     = [];
      this.ConnectionID       = [];
      this.resetHubSelection();

      this.input = {
        source: parseInt(this.sourceHubId.value),
        type: parseInt(this.routetype.value)
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'getroutemaster',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          for (let i = 0; i < result.data.ResponseData.length; i++) {
            this.listConnection.push({
              value: result.data.ResponseData[i].ConnectionID,
              text: result.data.ResponseData[i].ConnectionName + ' ( TP' + result.data.ResponseData[i].Stoppoints.length + ' )',
              FullConnectionName: result.data.ResponseData[i].FullConnectionName
            })
          }
        } else {
          this.$alertify.error("No Connection Found!")
        }
        this.connectionLoading = '';
      }, error => {
        this.connectionLoading = '';
        this.$alertify.error("Connection API Error", "", "error");
        console.error(error);
      })
    },

    getHubZoneData() {

      this.zoneLoading = 'Loading Zone...';
      this.resetHubSelection();
      this.listConnection = [];
      this.ConnectionID   = [];
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let listHubZoneData = result.data.ResponseData;
            for (let i = 0; i < listHubZoneData.length; i++) {
              this.listHubZoneData.push({
                value: listHubZoneData[i].hubzoneid,
                text: listHubZoneData[i].hubzonename
              })
            }
          }
          this.zoneLoading = '';
        }, error => {
          this.zoneLoading = '';
          console.error(error);
        })
    },

    getSourceHubNameList(zoneid) {
      this.sourceHubLoading = 'Loading Hub...'
      this.listSourceHubNameData = [];
      this.sourceHubIdArr=[];
      this.$validator.reset('sourceHubIdArr')
      this.sourceHubId= null;
      this.listConnection = [];
      this.ConnectionID   = [];
      this.resetHubSelection();

      this.input = ({
        hubZoneId: zoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.listSourceHubNameData = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID, hubcode: i.HubCode }));
          }
          this.sourceHubLoading = '';
        }, error => {
          this.sourceHubLoading = '';
          console.error(error)
        })
    },

    onSubmit: function() {
       this.$validator.validateAll()
        .then((result) => {

          if (Object.keys(this.routetype).length <= 0 || !this.sourceHubId || !this.sourceHubId.value || Object.keys(this.ConnectionID).length <= 0){
            document.getElementById("route").innerHTML= (Object.keys(this.routetype).length <= 0) ? 'The Route Type field is required.':'';
            document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
            document.getElementById("conn").innerHTML= (Object.keys(this.ConnectionID).length <= 0) ? 'The Connection Name field is required.':'';
            return false;
          }

          if (!result) {
            console.log('errors exist', this.errors);
            return false;
          } else {
            this.getDestinationsByConnection();
          }
        }).catch(() => {
          console.log('parent search errors exist', this.errors);
        });
    },

    resetForm() {
      this.hubzoneid= '',
      this.routetype= {},
      this.sourceHubId= null,
      this.listSourceHubNameData= [],
      this.ConnectionID= [],
      this.listConnection= [],
      this.modelArr= [],
      this.HubArr= [],
      this.destData= [],
      this.checked= [],
      this.connectionDestList= [],
      this.addmodalShow= false,
      this.checkAllHub= false,
      this.totalmappedhubs= 0,
      this.zoneLoading= '',
      this.sourceHubLoading= '',
      this.connectionLoading= '',
      this.hubLoading= '',
      this.connDestLoading= false,
      document.getElementById("route").innerHTML='',
      document.getElementById("source").innerHTML='',
      document.getElementById("conn").innerHTML='',
      this.$validator.reset();
      this.sourceHubIdArr=[]
      
    },

    closeStatusModal() {
      this.addmodalShow = false
    },

    getDestinationsByConnection() {
      if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.sourceHubId).length <= 0) { return false; }

      this.connDestLoading    = true;
      this.destData           = [];
      this.modelArr           = [];
      this.connectionDestList = [];
      this.totalmappedhubs    = 0;
      this.checkAllHub        = false;
      this.checked            = [];

      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "fetchAllocatedHubToConnectionByConnection_V1?connectionid="+this.ConnectionID.value,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j=0; let list=[]; let dlist=[];

            let hData = result.data.ResponseData;
            for (var i = 0; i < hData.length; i++) {
              if(j<4){
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
              }else{
                dlist.push(list);
                list=[]
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
                j=0;
              }
              j++;

              if(hData[i].isHubSelected==true){
                this.modelArr.indexOf(hData[i].HubID) === -1 ? this.modelArr.push(hData[i].HubID):'';
                this.checked[hData[i].HubID] = true;
              }

              this.destData.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName
              });
            }
            dlist.push(list);
            this.connectionDestList = dlist;

            this.totalmappedhubs  = result.data.TotalCount;
            if(this.modelArr.length == this.destData.length) this.checkAllHub = true;
          }else{
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.connDestLoading=false;
        }, error => {
          this.connDestLoading=false;
          console.error(error)
        })
    },

   checkHub() {
     if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
     this.modelArr = [];

     if (this.checkAllHub) {

       for (var i = 0; i < this.destData.length; i++) {
         this.checked[this.destData[i].hubId]=true;
       }

       this.modelArr = [...new Set(this.destData.map(a => a.hubId))];
     }else{

       this.checked=[];
     }
   },

   updateCheckDest(event){
     this.checked[event.target.id] = event.target.checked;

     if(event.target.checked==false){
       this.modelArr = this.modelArr.filter(el => el != event.target.id)

     }else{
       this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
     }

     this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
   },

    onSubmitHub: function(elem) {
     this.$validator.validateAll('hubsave').then((result) => {
       if (result) {
         if (Object.keys(this.ConnectionID).length <= 0 || Object.keys(this.sourceHubId).length <= 0 || this.modelArr.length <= 0) {
           this.$alertify.error('Destination selection or connection should not be empty!'); return false;
         }else{
           this.addmodalShow = true
         }
       }else{
         return false;
       }
     }).catch(() => {});
   },

    mapMultipleHubsToConnection() {
     this.connDestLoading = true;

     this.HubArr = this.destData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));

     this.input = ({
      sourceHubId: this.sourceHubId.value,
      sourceHubName: this.sourceHubId.text,
      connectionId: this.ConnectionID.value,
      connectionName: this.ConnectionID.text,
      hubCode: this.sourceHubId.hubcode,
      hubIdAndHubName: this.HubArr,
      createdBy: this.useremail
     })
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + "allocateMultipleHubToConnection_V1",
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           this.getDestinationsByConnection();
           user_tracker.checkUserIP(this.userData[0], "connectionhub", this.$route.path , this.input);
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   },

    takeAction() {
     this.mapMultipleHubsToConnection();
   },

   resetHubSelection() {
    this.checkAllHub= false,
    this.connectionDestList= [],
    this.totalmappedhubs= 0,
    this.modelArr= [],
    this.checked= [],
    this.connDestLoading= false
    // this.sourceHubIdArr=[]
  },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/connectionhubnew/connectionhubnew.component.js